export const HTTP_UNAUTHORIZED = 401;
export const STATUSES = ["New", "Reviewing", "Missing Documents", "Approved", "Declined", "Funded"];
